query TravelAuthorizationChartData {
  kpiTravelAuthorizationPolicyBreakdowns(first: 8, orderBy: SORT_ORDER_ASC) {
    nodes {
      id
      name
      activeAmount
      activeSearchParam
      pendingAmount
      pendingSearchParam
      inPolicyAmount
      inPolicySearchParam
      outOfPolicyAmount
      outOfPolicySearchParam
    }
  }
}
